export const LOG_OUT_ACTION = "LOG_OUT"
export const PRE_LOG_OUT_ACTION = "PRE_LOG_OUT"
export const FETCH_PROFILE_SUCCESS_ACTION = "FETCH_PROFILE_SUCCESS"
export const SUBMIT_LOGIN_FORM_ACTION = "SUBMIT_LOGIN_FORM"
